import { useState, useEffect,useRef } from "react";
import "./DashboardVariable.css";
import '/src/components/UI/Button/IconButton/IconButton.css'
import CheckBox from '/src/components/UI/CheckBox/CheckBox';
function DashboardToggle({ data, className, postbackAction }) {
    const [state, setState] = useState(parseInt(data.value) == 0 || data.value == false ? false : true);
    const [switchTimer, setSwitchTimer] = useState(null);
    const ref = useRef(null);
    const switchButton = () => {
        setState(!state);
        saveData(!state == false ? false : true);
    }
    
    const saveData = (value) => {
        if (postbackAction == null) return;
        console.log(value);
        clearTimeout(switchTimer);
        setSwitchTimer(setTimeout(() => {
            postbackAction(value);
        }, 1500));
    }

    useEffect(()=>{
        if (ref.current != null && switchTimer == null) {
            ref.current.checked = data.value == false ? false : true
        }
    },[data])
    return (
        <>
            <CheckBox ref={ref}name={data.label + Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1)} checked={state} onChange={() => switchButton()} classNameMainContainer={"checkbox dashboard_checkbox " + (className ? className : "")} defaultChecked={data.value} />
        </>
    );
}

export default DashboardToggle;